import Editor from '@toast-ui/editor';
import colorSyntax from '@toast-ui/editor-plugin-color-syntax';
import codeSyntaxHighlight from '@toast-ui/editor-plugin-code-syntax-highlight';
import { uploadFile, removeFileAttachment } from "./file_handler.js";
import { validateFile } from "./file_validator.js";

const ContentEditor = {
  mounted() {
    let theme = localStorage.getItem('hs_theme') || (document.querySelector('html').classList.contains('dark') ? 'dark' : 'light')
    this.previousImages = getCurrentImages(document.querySelector("#item-content").value);

    this.handleEvent("update-editor-content", ({content}) => {
      // console.log("Event received:", content);
      try {
        if (this.editor) {
          const currentContent = this.editor.getMarkdown();
          // console.log("Current content:", currentContent);
          const separator = "\n\n";
          const newContent = currentContent + separator + content;
          // console.log("New content:", newContent);
          // document.getElementById("ai-content-generator").classList.add("hidden");

          this.editor.setMarkdown(newContent);
          document.getElementById("item-content").value = newContent;
        } else {
          // console.error("Editor not initialized");
        }
      } catch (error) {
        // console.error("Error handling content update:", error);
      }
    });

    const options = {
      usageStatistics: false,
      el: this.el,
      minHeight: '200px',
      initialEditType: 'wysiwyg',
      initialValue: document.querySelector("#item-content").value,
      hideModeSwitch: true,
      theme: theme,
      plugins: [colorSyntax, codeSyntaxHighlight],
      useCommandShortcut: true,
      extendedAutolinks: true,
      frontMatter: true,
    };
    this.editor = new Editor(options);

    // add the contents of this element to the item-content input on every key stroke
    this.editor.on('change', () => {
      const currentContent = this.editor.getMarkdown();
      const itemContentInput = document.querySelector("#item-content");
      itemContentInput.value = currentContent;

      // Get all form data
      const form = this.el.closest("form");

      // Serialize the form data without the item[prefix]
      const serializeForm = (form) => {
        let formData = new FormData(form);
        let serializedData = {};
        formData.forEach((value, key) => {
          // Check if the key has a prefix to remove
          if (key.startsWith("item[")) {
            key = key.replace(/^item\[|\]$/g, "");
          }
          serializedData[key] = value;
        });
        return serializedData;
      };
      let formData = serializeForm(form);
      // Push the change event to LiveView with all form data
      this.pushEventTo(form, "validate", {
        _target: ["item", "content"],
        item: formData
      });

      // Check for removed images
      this.maybeRemoveImageUploaded(currentContent);
    });

    // Handle image upload
    this.editor.on('addImageBlobHook', async (blob, callback, source) => {
      try {
        validateFile(blob);
        const fileUrl = await uploadFile(blob);

        // Get current markdown content
        let currentContent = this.editor.getMarkdown();

        // Replace the last occurrence of a base64 image with the URL
        const base64Pattern = /!\[[^\]]*\]\(data:image\/[^)]+\)/g;
        const matches = currentContent.match(base64Pattern);

        if (matches && matches.length > 0) {
          // Replace the last occurrence
          const lastMatch = matches[matches.length - 1];

          // Extract the placeholder name from the lastMatch
          const placeholderName = lastMatch.match(/!\[([^\]]*)\]/)[1];
          const newImageMarkdown = `![${placeholderName}](${fileUrl})`;
          currentContent = currentContent.replace(lastMatch, newImageMarkdown);

          // Set the updated content
          this.editor.setMarkdown(currentContent);
        } else {
          // If no match found, insert the new image at the cursor position
          const newImageMarkdown = `![${blob.name}](${fileUrl})`;
          this.editor.insertText(newImageMarkdown);
        }

        // Prevent default behavior
        return false;
      } catch (error) {
        this.timer = setTimeout(() => {

          document.getElementById("file-type-error").classList.add("hidden");
          document.getElementById("file-size-error").classList.add("hidden");
          document.getElementById("file-quota-error").classList.add("hidden");
        }, 15000);
      }
      this.timerBs = setTimeout(() => {
        document.getElementById("b-s-file-error").classList.add("hidden");
      }, 15000);
    });

    this.maybeRemoveImageUploaded = (currentContent) => {
      const currentImages = getCurrentImages(currentContent);
      // Compare with previous images and remove those that are no longer present
      if (this.previousImages) {
        const removedImages = this.previousImages.filter(img => !currentImages.includes(img));
        removedImages.forEach(imageUrl => {
          // TODO: handle errors
          removeFileAttachment(imageUrl);
        });
      }

      // Update the previous images for the next change event
      this.previousImages = currentImages;
    };
    function getCurrentImages(content) {
      const imageRegex = /!\[.*?\]\((.*?)\)/g;
      return [...content.matchAll(imageRegex)].map(match => match[1]);
    }
  },
  destroyed() {
    if (this.editor) {
      this.editor.destroy();
    }
  }
};

export default ContentEditor;
